import type { FaireProductEntity } from "../../entity_types/product";

export const p_rmcp88j5zw: FaireProductEntity = {
  token: "p_rmcp88j5zw",
  type: "product",
  name: "Minnesota Themed 100% Soy Wax Candles and Melts",
  brandName: "Lorabees",
  imageUrl:
    "https://cdn.faire.com/fastly/caa44f688ca1a4c17db7ec9746db105dc9b410b1b9629209651b52a2c359fb98.jpeg",
  priceDollars: 3.75,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/6480e9e67fba15df39fcb3e58a871b9ae81114fafa2c3bb79f1af3c480ae5dbb.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
